
import textMixin from '~/mixins/textMixin'

export default {
  mixins: [textMixin],

  props: {
    tag: {
      type: String,
      default: 'h2',
      validator: value =>
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value)
    }
  },

  computed: {
    classes () {
      return {
        BaseHeading: true,
        ...this.textClasses
      }
    }
  },

  render (createElement) {
    return createElement(`${this.tag}`, { class: this.classes }, [
      this.$slots.default
    ])
  }
}
